import { createSlice } from "@reduxjs/toolkit";
import { getProduct, getProductById } from "../../reduxApi/admin/ProductReduxApi";

const productSlice = createSlice({
    name: 'inventory',
    initialState: {
        status: 'idle',
        isFiltered: false,
        inventory: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteinventoryAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.inventory.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.inventory.splice(index, 1);
                }
            });
        },
        updateinventoryAction: (state, action) => {
            const index = state.inventory.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.inventory.splice(index, 1, { inventorys: action.payload })
            }
        },
        addinventoryAction: (state, action) => {
            console.log("action--->", action.payload);

            const temp = action.payload;
            console.log("temp", temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID", temp.ROWID);

            state.inventory.unshift({ inventorys: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProduct.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getProduct.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.inventory =
                    action.payload?.inventory ||
                    action.payload?.data?.inventory ||
                    [];
                console.log("state.inventory", state.inventory)
            })

            // get product by ID
            .addCase(getProductById.fulfilled, (state, action) => {
                const product = action.payload?.inventory?.[0];

                if (!product) return;

                const exists = state.inventory.find(
                    (item) => (item.inventorys || item).ROWID === product.ROWID
                );

                if (!exists) {
                    state.inventory.push(product);
                }
            });
    },
})
export const { deleteinventoryAction, updateinventoryAction, addinventoryAction, setFilteredStatus } = productSlice.actions
export default productSlice.reducer
